import React, { useState, useEffect } from 'react';
import '../styles/FAQs.css';

const FAQs = ({ onClose }) => {
    const [expandedIndex, setExpandedIndex] = useState(null);

    const faqItems = [
        {
            question: 'Is CLIP AND GO free to use?',
            answer: 'Yes, CLIP AND GO is completely free to use. We rely on the support of our community through the "Buy Me a Coffee" link to help maintain and improve our web tools. Your support helps us keep the service running smoothly.',
            showButton: true
        },
        {
            question: 'Can I reuse my Page URL?',
            answer: 'Yes, You can bookmark the page URL in your browser and create shortcuts on your mobile device for quick access. Simply click the bookmarked URL or shortcut to access your clipboard anytime. No need to generate a new page URL every time you want to use the app.',
            showImages: true
        },
        {
            question: 'When does my Page URL expire?',
            answer: 'Your Page URL will expire after 30 days of inactivity. This means if you have not used your clipboard for 30 consecutive days, the clipboard and its associated URL will be automatically deleted to keep our database clean and efficient.'
        },
        {
            question: 'Is my data secure on CLIP AND GO?',
            answer: 'Your data is encrypted during transmission and storage. However, since Clip and Go doesn\'t require a password to access, we do not recommend using it for super sensitive or confidential information. It\'s best suited for sharing general text, links, and non-critical data between your devices.'
        }
    ];

    const toggleExpand = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    useEffect(() => {
        // Load the Buy Me a Coffee script when FAQs modal is shown
        if (window.location.pathname) {
            const script = document.createElement('script');
            script.src = 'https://cdnjs.buymeacoffee.com/1.0.0/button.prod.min.js';
            script.setAttribute('data-name', 'bmc-button');
            script.setAttribute('data-slug', 'inklab');
            script.setAttribute('data-color', '#FFDD00');
            script.setAttribute('data-emoji', '☕');
            script.setAttribute('data-font', 'Cookie');
            script.setAttribute('data-text', 'Buy Me a Coffee');
            script.setAttribute('data-outline-color', '#000000');
            script.setAttribute('data-font-color', '#000000');
            script.setAttribute('data-coffee-color', '#ffffff');
            script.async = true;
            document.body.appendChild(script);

            return () => {
                // Cleanup if needed
            };
        }
    }, []);

    return (
        <div className="faqs-overlay" onClick={onClose}>
            <div className="faqs-container" onClick={(e) => e.stopPropagation()}>
                <button className="faqs-close" onClick={onClose}>✕</button>
                
                <div className="faqs-content">
                    <h1>FAQs</h1>
                    
                    <div className="faq-list">
                        {faqItems.map((item, index) => (
                            <div key={index} className="faq-item">
                                <button 
                                    className="faq-question"
                                    onClick={() => toggleExpand(index)}
                                >
                                    <span className="faq-text">{item.question}</span>
                                    <span className={`faq-toggle ${expandedIndex === index ? 'expanded' : ''}`}>
                                        ▼
                                    </span>
                                </button>
                                {expandedIndex === index && (
                                    <div className="faq-answer">
                                        <p>{item.answer}</p>
                                        {item.showImages && (
                                            <div className="faq-images-container">
                                                <div className="faq-image-column">
                                                    <img src={`${process.env.PUBLIC_URL}/Bookmark.jpg`} alt="Bookmark Example" className="faq-image" />
                                                    <p className="image-caption">Bookmark the Page URL on Computer</p>
                                                </div>
                                                <div className="faq-image-column">
                                                    <img src={`${process.env.PUBLIC_URL}/Shortcut2.jpg`} alt="Shortcut Example" className="faq-image" />
                                                    <p className="image-caption">Create a Shortcut Icon on Mobile</p>
                                                </div>
                                            </div>
                                        )}
                                        {item.showButton && (
                                            <div className="bmc-button-container">
                                                <a href="https://buymeacoffee.com/inklab" target="_blank" rel="noopener noreferrer">
                                                    <button className="bmc-button">
                                                        ☕ Buy me a coffee
                                                    </button>
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQs;
